<template>
  <v-select
    id="municipio-select"
    v-model="filter.municipio"
    item-text="nome"
    item-name="municipioId"
    :items="municipios"
    label="Município"
    placeholder="Município"
    @change="$emit('changeCity')"
    :multiple="isMultiple ? true : false"
    :return-object="true"
    clearable
  >
    <template slot="no-data"> Nenhum Município retornado </template>
  </v-select>
</template>

<script>
import { cityAPI } from "@/modules/city";

export default {
  name: "AppCityComboboxSingle",
  props: ["filter", "isMultiple"],
  mounted() {
    this.loadCities();
  },
  methods: {
    loadCities() {
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      municipios: [],
    };
  },
};
</script>
